import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import surveyService from '../services/surveyService';
import toast from 'react-hot-toast';

const SurveyTest = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const testCreateSurvey = async () => {
    try {
      setLoading(true);
      console.log('🧪 Iniciando teste de criação de levantamento');

      const testData = {
        client_name: 'Teste Cliente',
        client_phone: '(11) 99999-9999',
        client_email: 'teste@email.com',
        client_address: 'Rua de Teste, 123 - São Paulo/SP',
        environment_description: 'Ambiente de teste',
        technical_observations: 'Observações de teste',
        plumbing_info: 'Encanamento de teste',
        furniture_purpose: 'Móveis de teste',
        status: 'DRAFT',
        priority: 'NORMAL'
      };

      console.log('📝 Dados de teste:', testData);
      console.log('👤 Usuário logado:', user);

      const response = await surveyService.createSurvey(testData);
      console.log('✅ Teste concluído com sucesso:', response);
      toast.success('Teste de criação funcionou!');

    } catch (error) {
      console.error('❌ Teste falhou:', error);
      toast.error('Teste falhou: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const testGetStats = async () => {
    try {
      setLoading(true);
      console.log('🧪 Testando busca de estatísticas');

      const response = await surveyService.getStats();
      console.log('✅ Estatísticas obtidas:', response);
      toast.success('Teste de estatísticas funcionou!');

    } catch (error) {
      console.error('❌ Teste de stats falhou:', error);
      toast.error('Teste de stats falhou: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const testGetSurveys = async () => {
    try {
      setLoading(true);
      console.log('🧪 Testando busca de levantamentos');

      const response = await surveyService.getAllSurveys();
      console.log('✅ Levantamentos obtidos:', response);
      toast.success(`Teste funcionou! ${response.data?.length || 0} levantamentos encontrados`);

    } catch (error) {
      console.error('❌ Teste de listagem falhou:', error);
      toast.error('Teste de listagem falhou: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow">
      <h2 className="text-xl font-bold mb-4">🧪 Teste do Sistema de Levantamento</h2>
      
      <div className="space-y-4">
        <div className="bg-blue-50 p-4 rounded">
          <p><strong>Usuário:</strong> {user.full_name} ({user.role})</p>
          <p><strong>ID:</strong> {user.id}</p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={testGetStats}
            disabled={loading}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
          >
            {loading ? 'Testando...' : '📊 Testar Stats'}
          </button>

          <button
            onClick={testGetSurveys}
            disabled={loading}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Testando...' : '📋 Testar Listagem'}
          </button>

          <button
            onClick={testCreateSurvey}
            disabled={loading}
            className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 disabled:opacity-50"
          >
            {loading ? 'Testando...' : '🆕 Testar Criação'}
          </button>
        </div>

        <div className="bg-yellow-50 p-4 rounded">
          <h3 className="font-bold mb-2">📝 Instruções:</h3>
          <ol className="text-sm space-y-1">
            <li>1. Clique em "📊 Testar Stats" primeiro</li>
            <li>2. Depois clique em "📋 Testar Listagem"</li>
            <li>3. Por último, clique em "🆕 Testar Criação"</li>
            <li>4. Verifique o console do navegador para logs detalhados</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default SurveyTest;
